import ReactJson from "react-json-view";
import { Card } from "@mantine/core";
import JsonViewer from "./jsonViewer";

const AIRequestOutput = ({ form, name }) => {
  const aiRequest = form.values;

  return (
    <Card withBorder style={{ padding: "5px", margin: "0px" }}>
      <JsonViewer data={aiRequest.outputs} name="outputs" />
    </Card>
  );
};

export default AIRequestOutput;
